import { Alerta, Badge, DataList, Select, Spinner, Stack } from "@/components";
import type { Aviso } from "@/lib/api";
import { ETIQUETA_CANAL_AVISO, ETIQUETA_ESTADO_AVISO, ETIQUETA_TIPO_AVISO, OPCIONES_FILTRO_CANAL, OPCIONES_FILTRO_ESTADO, TONO_ESTADO_AVISO } from "@/lib/avisos";
import { formatFechaLocal } from "@/lib/format";
import { useAvisosTab } from "./useAvisosTab";

export function AvisosTab() {
  const t = useAvisosTab();
  const columnas = [
    { clave: "fecha", titulo: "Fecha", render: (a: Aviso) => formatFechaLocal(a.creado_en) },
    {
      clave: "destinatario",
      titulo: "Destinatario",
      render: (a: Aviso) => (
        <span className="flex flex-col">
          <span>{a.nombre}</span>
          {a.email && <span className="text-chico text-texto-suave break-all">{a.email}</span>}
        </span>
      ),
    },
    { clave: "tipo", titulo: "Tipo", render: (a: Aviso) => ETIQUETA_TIPO_AVISO[a.tipo] },
    { clave: "canal", titulo: "Canal", render: (a: Aviso) => ETIQUETA_CANAL_AVISO[a.canal] },
    { clave: "estado", titulo: "Estado", render: (a: Aviso) => <Badge tono={TONO_ESTADO_AVISO[a.estado]}>{ETIQUETA_ESTADO_AVISO[a.estado]}</Badge> },
    { clave: "error", titulo: "Error", render: (a: Aviso) => (a.ultimo_error ? <span className="text-chico text-peligro">{a.ultimo_error}</span> : null) },
  ];
  return (
    <Stack espacio={6}>
      <h1 className="text-pantalla font-light tracking-[-0.03em]">Avisos</h1>
      <p className="text-chico text-texto-suave">
        Los avisos que mandó el sistema por mail y al celular (los últimos 200). Lo que falla se reintenta una vez por día, hasta 5 veces.
      </p>
      <div className="flex flex-wrap gap-3">
        <Select etiqueta="Estado" opciones={OPCIONES_FILTRO_ESTADO} valor={t.estado} onCambio={t.cambiarEstado} className="max-w-xs" />
        <Select etiqueta="Canal" opciones={OPCIONES_FILTRO_CANAL} valor={t.canal} onCambio={t.cambiarCanal} className="max-w-xs" />
      </div>
      <Alerta texto={t.error} />
      {t.cargando ? (
        <div className="grid place-items-center py-10 text-primario">
          <Spinner />
        </div>
      ) : (
        <DataList etiqueta="Avisos enviados" columnas={columnas} filas={t.avisos} claveFila={(a) => a.id} vacio="Todavía no se mandó ningún aviso." />
      )}
    </Stack>
  );
}
